import React from 'react';
import NetflixGallery, { WidgetPreview, WidgetPreviewStatic } from './NetflixGallery';
import _ from 'lodash';

const WidgetHeader = ({ text }) => (
    <h3
        style={{
            textAlign: 'left',
        }}
    >
        {text}
    </h3>
);

const WidgetList = ({
    widgets,
    groupBy = 'category',
    wide = true,
    sortBy = () => 0,
    filter = () => true,
    onClick,
    wdpcache = 'widget',
    template,
    propsForWidgets = () => ({}),
}) => {
    const groups = {};

    widgets = _.chain(widgets)
        .groupBy(w => _.get(w, 'spec.widgetGroup', w.id))
        .toPairs()
        .map(([groupKey, widgets]) => {
            return [groupKey, _.orderBy(widgets, w => -_.get(w, 'spec.groupWeight', 0))];
        })
        .map(([groupKey, [master, ...rest]]) => {
            master.layoutsWidgets = [master, ...rest];
            master.layouts = master.layoutsWidgets.length;
            return master;
        })
        .value();

    _.each(widgets.filter(w => w.spec.social), w => {
        const groupKey = _.get(w, `${groupBy}`);

        if (_.isArray(groupKey)) {
            // console.log(w.id, groupKey);
            groupKey.forEach(g => {
                groups[g] = groups[g] || [];
                groups[g].push(w);
            });
        } else if (groupKey) {
            groups[groupKey] = groups[groupKey] || [];
            groups[groupKey].push(w);
        }
    });
    const categories = _.chain(groups)
        .toPairs()
        .filter(filter)
        .sortBy(sortBy) // sort categories
        .map(([category, widgets]) => [category, _.orderBy(widgets, w => -_.get(w, 'spec.weight', 0))]) // sort widgets in a row
        .value();

    if (!wide) {
        return (
            <WidgetColumnList
                categories={categories}
                wdpcache={wdpcache}
                template={template}
                onClick={onClick}
                propsForWidgets={propsForWidgets}
            />
        );
    }

    return (
        <WidgetNetflix
            categories={categories}
            wdpcache={wdpcache}
            template={template}
            onClick={onClick}
            propsForWidgets={propsForWidgets}
        />
    );
};
const translations = {
    TOURNAMENT_FIXTURES: 'Fixtures & Results',
    TOURNAMENT_TABLES: 'Standings',
    MATCH_PRE: 'Pre match',
    MATCH_LIVE: 'Live',
    PLAYERS_STATS: 'Player stats',
    PLAYERS_H2H: 'Player compare',
    TEAMS: 'Team',
    TOP_LIST: 'Top-lists',
    TRANSFERS: 'Transfer news',
    EDITORIAL: 'Editorial pick',
    ODDS: 'Bookie widgets',
    BASEBALL: 'Baseball',
};

const WidgetNetflix = ({ categories, zoomFactor, onClick, wdpcache, template, propsForWidgets = () => ({}) }) => (
    <div>
        {categories.map(
            ([category, widgets]) =>
                category !== 'unknown' && (
                    <div key={category}>
                        <WidgetHeader text={translations[category] || category} />

                        <NetflixGallery
                            key={category + '_'}
                            list={widgets}
                            zoomFactor={zoomFactor}
                            renderKey={w => `${w.key || w.id}_${template}`}
                            renderFullView={() => <div />}
                            renderItem={(w, props) => (
                                <WidgetPreview
                                    key={w.key || w._id || w.id}
                                    {...props} // props from netflix gallery
                                    widget={w}
                                    widgetId={w.id}
                                    props={{ ...(w.props || {}), template }}
                                    wdpcache={wdpcache}
                                    template={template}
                                    allowZoom
                                    {...propsForWidgets(w)}
                                    onClick={e => {
                                        if (onClick) onClick(e, w, template);
                                    }}
                                />
                            )}
                        />
                    </div>
                ),
        )}
    </div>
);

const WidgetColumnList = ({ categories, onClick, wdpcache, template, propsForWidgets }) => (
    <div>
        {categories.map(
            ([category, widgets]) =>
                category !== 'unknown' && (
                    <div key={category}>
                        <WidgetHeader text={translations[category] || category} />

                        {widgets.map(w => (
                            <WidgetPreviewStatic
                                key={w.key || w._id || w.id}
                                widget={w}
                                widgetId={w.id}
                                props={{ ...(w.props || {}), template }}
                                wdpcache={wdpcache}
                                template={template}
                                {...propsForWidgets(w)}
                                onClick={e => {
                                    if (onClick) onClick(e, w, template);
                                }}
                            />
                        ))}
                    </div>
                ),
        )}
    </div>
);

export default WidgetList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/WidgetList.js
 **/